"use strict";
const LEGACY_CARRIER_INVOICE_PATH = new RegExp("^(?:\\/index-document-batches\\/\\d+)?\\/loads\\/\\d+\\/carrier_invoices\\/(?<id>\\d+)$");
export function carrierInvoiceWorkflowRedirect(path) {
  const [pathname, search] = path.split("?");
  const query = new URLSearchParams(search);
  if (query.has("forceReact")) {
    return null;
  }
  const match = pathname.match(LEGACY_CARRIER_INVOICE_PATH);
  if (!match) {
    return null;
  }
  const target = `/carrier_invoices_workflow/${match.groups.id}`;
  const onDone = query.get("onDone");
  return onDone ? `${target}?onDone=${encodeURIComponent(onDone)}` : target;
}
